import { Transition as t } from "@headlessui/react";

export const Transition = t;
